import { LOAD, UPDATE } from 'model/oneTimePasscodeEventConfig';
import { load, update } from 'sdk/oneTimePasscodeEventConfig';
import { takeEvery } from 'redux-saga/effects';
import { callAction, ORM } from '../util';
import { formatSuccessMessage, OTP_EVENT_LABEL, UPDATED } from '../consts';
import { loadFSPProfileAction } from './export';

const keyName = { key: '', name: OTP_EVENT_LABEL };

export const updateOneTimePasscodeEventConfig = () =>
  callAction({
    api: update,
    dataName: ORM,
    formatSuccessMessage: formatSuccessMessage(keyName, UPDATED, false),
    type: UPDATE,
  });

function* updateAndPopulateExport(action) {
  const updateAction = updateOneTimePasscodeEventConfig();

  if (yield updateAction(action)) {
    yield loadFSPProfileAction(action);
  }
}

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeEvery(UPDATE.ACTION, updateAndPopulateExport);
}
